// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import Media from "react-media";
import OrderSensitiveAccountTab from "../../AccountType/Tab";
import Gettext from "../../common/Gettext";
import { Cup as Icon } from "../../Icons/Tournaments";
import TournamentAPI from "../Api";

import type { AccountType } from "../../AccountType/AccountInHeader";

type Api = {
  fetchEntity: any,
  readEntity: any
};

const Heading = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CupIcon = styled(Icon)`
  ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      color: #3b9478;
    `};
`;

type Props = {
  api: Api,
  currentTab?: AccountType,
  onClick: (tab: AccountType) => boolean | void
};

export default function TournamentTab(props: Props) {
  return (
    <TournamentAPI.Consumer>
      {(api: Api) => (
        <OrderSensitiveAccountTab
          tab="tournament"
          currentTab={props.currentTab}
          onClick={tab => {
            api.fetchEntity("/api/tournaments/list?status=1");
            api.fetchEntity(
              `/api/tournaments/list?status=1&participation_status=1`
            );
            props.onClick(tab);
          }}
        >
          <Heading>
            <Media
              query="(min-width: 480px)"
              render={() => (
                <CupIcon
                  width="16px"
                  height="20px"
                  style={{ marginRight: 5 }}
                />
              )}
            />
            <Gettext>Tournaments</Gettext>
          </Heading>
        </OrderSensitiveAccountTab>
      )}
    </TournamentAPI.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/Account/Tab.js